import axios from '../script/axiosAMS'

export default {
  signup (data, resultCallback) {
    axios.requestWith({
      url: '/api/user/signup',
      method: 'put',
      data: data,
      resultCallback: resultCallback
    })
  },
  login (data, resultCallback) {
    axios.requestWith({
      url: '/api/user/login',
      method: 'post',
      data: data,
      resultCallback: resultCallback
    })
  },
  checkDuplicate (params, resultCallback) {
    axios.requestWith({
      url: '/api/user/checkDuplicate',
      method: 'get',
      params: params,
      resultCallback: resultCallback
    })
  },
  getUser (params, resultCallback) {
    axios.requestWith({
      url: '/api/user',
      method: 'get',
      params: params,
      resultCallback: resultCallback
    })
  },
  user (data, resultCallback) {
    axios.requestWith({
      url: '/api/user',
      method: 'post',
      data: data,
      resultCallback: resultCallback
    })
  },
  changePassword (data, resultCallback) {
    axios.requestWith({
      url: '/api/user/changePassword',
      method: 'post',
      data: data,
      resultCallback: resultCallback
    })
  },
  refreshToken (params, resultCallback) {
    axios.requestWith({
      url: '/api/user/refreshToken',
      method: 'get',
      params: params,
      resultCallback: resultCallback
    })
  },
  useStates (data, resultCallback) {
    axios.requestWith({
      url: '/api/user/useStates',
      method: 'post',
      data: data,
      resultCallback: resultCallback
    })
  }
}



// WEBPACK FOOTER //
// ./src/script/user.js